export default "__VITE_ASSET__478ef22b__"